export const hubspotForms = {
  'welcome-series': '3c01d2c9-d9f1-472a-8803-d99c3c264c49',
  'monthly-fh-opt-in': '384942c5-8635-46f7-8586-6460af0a2660',
  'notify-impact-report': 'a208eb07-ab77-48a7-a875-e96a68e671eb',
  'contact-us': '3ee3a21d-472d-4950-ab13-a9b09fb5d21b',
};

export const zoomForms = {
  standup: 'https://zoom.us/webinar/register/WN_Sh2acAKZQZ-bdKFWpuJVwQ',
};
